
import utils from '@/utils/utils'
const lang = utils.browserLanguage()

const Time = { // 时间国际化
  countdown: {
    zh: ['天', '时', '分'],
    fn: ['天', '時', '分'],
    en: ['d ', 'h ', 'm']
  }
}

export function filterCountdown(msec) {
  const dateNow = new Date() // 获取当前时间
  const nowData = Number(dateNow.getTime()) / 1000
  const $timeDiff = msec - nowData// 时间差的毫秒数
  // 计算天数
  var $days = parseInt($timeDiff / 86400)
  // 计算小时数
  var $hoursDiff = $timeDiff % 86400
  var $hours = parseInt($hoursDiff / 3600)
  // 计算分钟数
  var $minsDiff = $hoursDiff % 3600
  var $mins = parseInt($minsDiff / 60)

  return `${$days}${Time.countdown[lang][0]}${$hours}${Time.countdown[lang][1]}${$mins}${Time.countdown[lang][2]}`
}

export function formatTime(str = 0) {
  if (!str) { return '' }
  const date = new Date(parseInt(str) * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return `${y}-${m}-${d} ${h}:${minute}:${second}`
}

export function formatTimes(str = 0) {
  if (!str) { return '' }
  const date = new Date(parseInt(str) * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  return `${m}.${d} ${h}:${minute}`
}

export function formatDay(str = 0) {
  if (!str) { return '' }
  const date = new Date(parseInt(str) * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  return `${m}.${d}`
}

export function statusText($code = 0) {
  switch (Number($code)) {
    case 1:
      return '线上'
    case 2:
      return '待审核'
    default: return '审核不通过'
  }
}
